module.exports = __webpack_public_path__ + "img/double_chevron_up.0acc05d9.svg";